module.exports = __webpack_public_path__ + "img/logo.161aaf7c.png";